import { render } from "./MratioTrend.vue?vue&type=template&id=19f54ce4&scoped=true"
import script from "./MratioTrend.vue?vue&type=script&lang=js"
export * from "./MratioTrend.vue?vue&type=script&lang=js"

import "./MratioTrend.vue?vue&type=style&index=0&id=19f54ce4&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f54ce4"]])

export default __exports__